<template>
  <div class="shipments-page">
    <table-filter class="mb-4" v-if="$route.name !== 'head-of-fleet-in-house-orders'" :filters="filters" :statusFilters="statusFilters" @changeFilter="changeFilter" @filterValue="filterValue = $event"/>
    <shipblu-table
      :sst="true" 
      v-model="selected" 
      multiple 
      orders
      @searchDate="handleSearchDate"
      @keyup.enter.native="handleSearchAllOrders" 
      @search="handleSearchAllOrders"
      searchDate
      advancedSearch
      :searchCriteria="searchCriteria"
      @selectedCriteria="selectedCriteria = $event"
      :data="shipments"
      :tableLoader="tableLoader"
    >
      <template slot="header">
        <div class="flex flex-wrap items-center gap-3 whitespace-nowrap">
          <export-button />
          <print-label-button v-if="$route.name !== 'head-of-fleet-in-house-orders'" :selected="selected"/>
        </div>
      </template>
      <template slot="thead">
        <shipblu-th>{{$t('Tracking No.')}}</shipblu-th>
        <shipblu-th>{{$t('Merchant')}}</shipblu-th>
        <shipblu-th>{{$t('Customer')}}</shipblu-th>
        <shipblu-th>{{$t('Zone')}}</shipblu-th>
        <shipblu-th>{{$t('Address')}}</shipblu-th>
        <shipblu-th>{{$t('PD')}}</shipblu-th>
        <shipblu-th v-if="$route.name === 'head-of-fleet-in-house-orders'" >{{$t('Pickup Date')}}</shipblu-th>
        <shipblu-th v-if="$route.name !== 'head-of-fleet-in-house-orders'">{{$t('GPS')}}</shipblu-th>
        <shipblu-th v-if="$route.name !== 'head-of-fleet-in-house-orders'">{{$t('DW')}}</shipblu-th>
        <shipblu-th>{{$t('Delivery Attempts')}}</shipblu-th>
        <shipblu-th v-if="$route.name === 'head-of-fleet-in-house-orders'">{{$t('Slots')}}</shipblu-th>
        <shipblu-th>{{$t('Estimated Delivery Date')}}</shipblu-th>
        <shipblu-th>{{$t('On Hold')}}</shipblu-th>
        <shipblu-th>{{$t('RTO')}}</shipblu-th>
        <shipblu-th>{{$t('Packages')}}</shipblu-th>
        <shipblu-th>{{$t('Package Size')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
      </template>
      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`" viewInPanel :to="{ query: { ...$route.query, order: data[indextr].id, tracking_number: data[indextr].tracking_number }}">
          <shipblu-td class="sm:hidden block col-span-2 p-0 order-3">
            <!-- line -->
            <p style="background-color: #DCDCDC;height: 1px;"></p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].tracking_number" class="text-left sm:order-3 order-25">
            <div class="flex sm:static absolute top-3 gap-2 items-start justify-start transform-50" v-on:click.stop>
              <p class="sm:text-base text-lg flex gap-1 items-start justify-center">
                <span class="sm:order-2 order-1">{{ data[indextr].tracking_number }}</span>
                <shipblu-icon @click.stop.prevent="common.copied(data[indextr].tracking_number)" iconLibrary="material" iconClass="text-grey hover:text-primary text-xl cursor-pointer sm:order-1 order-2" iconName="content_copy"></shipblu-icon>
              </p>
            </div>
          </shipblu-td>
          
          <shipblu-td class="order-4" :data="data[indextr].merchantName">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Merchant')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].merchant.name}}</p>
          </shipblu-td>

          <shipblu-td class="order-5" :data="data[indextr].customerName">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Customer')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].customer.full_name}}</p>
          </shipblu-td>

          <shipblu-td class="order-6" :data="data[indextr].zone">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Zone')}}</p>
            <p class="sm:text-base text-sm" v-if="data[indextr].customer.address.zone.city">{{ $t(data[indextr].customer.address.zone.name) }} / {{ $t(data[indextr].customer.address.zone.city.name) }}</p>
          </shipblu-td>

          <shipblu-td class="order-7" :data="data[indextr].loaction">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Address')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].customer.address.line_1}}</p>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].preferredDate">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('PD')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].preferred_date}}</p>
          </shipblu-td>

          <shipblu-td class="order-10" v-if="$route.name === 'head-of-fleet-in-house-orders'" :data="data[indextr].pickupDate">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Pickup Date')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].pickup_date ? new Date(data[indextr].pickup_date).toLocaleDateString('fr-CA') : '' }}</p>
          </shipblu-td>

          <shipblu-td class="order-13" v-if="$route.name !== 'head-of-fleet-in-house-orders'" :data="data[indextr].loactionLink">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('GPS')}}</p>
            <span v-if="data[indextr].customer.address.latitude" class="flex items-center">
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="h-5 w-6"
                class="text-green"
              />
            </span>
            <span v-else class="flex items-center">
              <feather-icon
                icon="XCircleIcon"
                svgClasses="h-5 w-6"
                class="text-red"
              />
            </span>
          </shipblu-td>

          <shipblu-td class="order-12" v-if="$route.name !== 'head-of-fleet-in-house-orders'" :data="data[indextr].preferred_window">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('PW')}}</p>
            <span v-if="data[indextr].preferred_window.length === 0" class="flex items-center">
              <feather-icon
                icon="XCircleIcon"
                svgClasses="h-5 w-6"
                class="text-red"
              />
            </span>
            <span v-else class="flex items-center">
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="h-5 w-6"
                class="text-green"
              />
            </span>
          </shipblu-td>

          <shipblu-td class="order-11" :data="data[indextr].deliveryAttempted">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Delivery Attempts')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].delivery_attempts}}</p>
          </shipblu-td>

          <shipblu-td class="order-14" :data="data[indextr].slots" v-if="$route.name === 'head-of-fleet-in-house-orders'">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Slots')}}</p>
            <p class="sm:text-base text-sm" v-for="packageItem in data[indextr].packages" :key="packageItem.index">{{ packageItem.package_location.aisle_sign ? packageItem.package_location.aisle_sign : packageItem.package_location.code }}</p>
          </shipblu-td>

          <shipblu-td class="order-15" :data="data[indextr].estimatedDate">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Estimated Date')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].estimated_date}}</p>
          </shipblu-td>

          <shipblu-td class="order-17" :data="data[indextr].on_hold">
            <template v-if="data[indextr].on_hold !== null">
              <div class="sm:text-base text-sm bg-warning h-3 w-3 inline-block rounded-full mr-2"></div>
              <span>On Hold</span>
            </template>
          </shipblu-td>

          <shipblu-td class="order-18" :data="data[indextr].RTO">
            <template v-if="data[indextr].rto_requested">
              <div class="sm:text-base text-sm bg-danger h-3 w-3 inline-block rounded-full mr-2"></div>
              <span>RTO</span>
            </template>
          </shipblu-td>

          <shipblu-td class="order-19" :data="data[indextr].packages">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Packages')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].packages ? data[indextr].packages.length : 'N/A'}}</p>
          </shipblu-td>

          <shipblu-td class="order-20" :data="data[indextr].packages">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Package Size')}}</p>
            <p class="sm:text-base text-sm" v-for="packageItem in data[indextr].packages" :key="packageItem.index">
              {{packageItem.package.package_size.short_code}}
            </p>
          </shipblu-td>

          <shipblu-td class="order-16" :data="data[indextr].status" style="white-space: nowrap;">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Status')}}</p>
            <div class="flex" style="width: fit-content;" @click="removeAttribute($event), openNotificationFailureData(data[indextr])">
              <span class="capitalize border border-solid rounded-4xl px-5 py-1.5 leading-none sm:text-sm text-xs text-white" :style="`background-color: ${getStyle(data[indextr])}`">{{ $t(getStatusLabel(data[indextr])) }}</span>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-cursor-pagination :maximumItems="maximumItems" :paginationObj="paginationObj" @changePageSize="changePageSize" @changePageNumber="changePageNumber($event)" />
    <order-view-panel :orderDataInfo="orderDataInfo" :showPanel="showPanel"></order-view-panel>
  </div>
</template>

<script>
import common from '@/assets/utils/common'
import {sendRequest} from '../../http/axios/requestHelper.js'
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ExportButton from './components/ExportButton.vue'
import PrintLabelButton from './components/PrintLabelButton.vue'
import TableFilter from '../merchant/components/TableFilter.vue'
import ShipbluCursorPagination from '../../layouts/components/ShipbluCursorPagination.vue'
import OrderViewPanel from '../merchant/components/OrderViewPanel.vue'

export default {
  data () {
    return {
      common,
      localStorage,
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      warehousesDic: {},
      paginationObj: {
        currentPage: 1,
        currentCursor: '',
        next: null,
        previous: null
      },
      selected: [],
      shipments: [],
      filters: [],
      statusFilters: [
        {
          name: 'all',
          value: 'all'
        },
        {
          name: 'created',
          value: 'created'
        },
        {
          name: 'pickup requested',
          value: 'pickup_requested'
        },
        {
          name: 'out for pickup',
          value: 'out_for_pickup'
        },
        {
          name: 'pickup rescheduled',
          value: 'pickup_rescheduled'
        },
        {
          name: 'picked up',
          value: 'picked_up'
        },
        {
          name: 'in transit & en route',
          value: 'in_transit, en_route'
        },
        {
          name: 'out for delivery',
          value: 'out_for_delivery'
        },
        {
          name: 'delivery attempted',
          value: 'delivery_attempted'
        },
        {
          name: 'delivered',
          value: 'delivered'
        },
        {
          name: 'RTO Requested',
          value: 'rto_requested'
        },
        {
          name: 'On Hold',
          value: 'on_hold'
        },
        {
          name: 'out for return',
          value: 'out_for_return'
        },
        {
          name: 'Returned',
          value: 'returned'
        },
        {
          name: 'cancelled',
          value: 'cancelled'
        }
      ],
      searchAllOrdersVal: '',
      searchInProgress: false,
      searchedValue: ' ',
      fromDate: '',
      toDate: '',
      criteria: '',
      tableLoader: false,
      headOfFleet: {},
      selectedCriteria: {},
      searchCriteria: [
        {
          label: 'Tracking No.',
          value: 'tracking_number'
        },
        {
          label: 'Reference No.',
          value: 'merchant_order_reference'
        },
        {
          label: 'Phone No.',
          value: 'phone'
        }
      ],
      showPanel: false,
      orderDataInfo: {}
    }
  },
  watch: {
    '$route.params.warehouseID' () {
      this.searchAllOrdersVal = ''
      this.maximumItems = process.env.VUE_APP_MAXIMUM_ITEMS_TABLE
      common.manageLoadWarehouses(this.formatWarehouses, this)
    },
    '$route.query.filter' () {
      if (!this.$route.query.filter) {
        this.filters = []
        this.loadDeliveryOrders()
      }
    },
    selected () {
      this.$emit('selected', this.selected)
    },
    '$route.query.order' (val) {
      if (val) {
        this.showPanel = true
      } else {
        this.loadDeliveryOrders(this.paginationObj.currentCursor)
        this.showPanel = false
      }
    }
  },
  methods: {
    viewOrder (data) {
      this.orderDataInfo = data
      this.$router.push({
        query: {
          ...this.$route.query,
          order: data.id
        }
      }).catch(() => {})
    },
    openNotificationFailureData (order) {
      common.openNotificationFailureData(this, order)
    },
    removeAttribute (event) {
      event.preventDefault()
    },
    changePageNumber (val) {
      this.paginationObj.currentPage = val === 'next' ? this.paginationObj.currentPage + 1 : this.paginationObj.currentPage - 1
      this.loadDeliveryOrders(this.paginationObj[val])
    },
    changePageSize (val) {
      localStorage.setItem('maxItems', val)
      this.maximumItems = val
      this.loadDeliveryOrders()
    },
    changeFilter () {
      const filtersTemp = this.filters
      this.filters = []
      filtersTemp.forEach(item => {
        this.filters.push(item)
      })
      this.filters.includes(this.filterValue) ? this.filters.splice(this.filters.indexOf(this.filterValue), 1) : this.filters.push(this.filterValue)
      if (this.filterValue === 'all' || (this.filterValue === 'rto_requested' && this.filters.includes('rto_requested')) || (this.filterValue === 'on_hold' && this.filters.includes('on_hold'))) {
        this.filters = []
        if (this.filterValue === 'rto_requested' && !this.filters.includes('rto_requested')) {
          this.filters.push('rto_requested')
        } else if (this.filterValue === 'on_hold' && !this.filters.includes('on_hold')) {
          this.filters.push('on_hold')
        }
      } else if (this.filters.includes('rto_requested')) {
        this.filters.splice(this.filters.indexOf('rto_requested'), 1)
      } else if (this.filters.includes('on_hold')) {
        this.filters.splice(this.filters.indexOf('on_hold'), 1)
      }
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters
        }
      }).catch(() => {})
      this.loadDeliveryOrders()
    },
    handleSearchDate (start, end, criteria) {
      this.fromDate = start ? new Date(start).toISOString().split('T')[0] : ''
      this.toDate = end ? new Date(end).toISOString().split('T')[0] : ''
      this.criteria = criteria
      this.loadDeliveryOrders()
    },
    handleSearchAllOrders (search) {
      this.searchAllOrdersVal = search ? search.target ? search.target.value : search : ''
      return common.manageSearch(search, this.loadOrdersSearch)
    },
    loadOrdersSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchAllOrdersVal) {
        return
      }
      this.loadDeliveryOrders()
    },
    formatWarehouses (warehouses) {
      warehouses.forEach(warehouse => {
        this.warehousesDic[warehouse.code] = warehouse.id
      })
    },
    loadDeliveryOrders (cursorVal) {
      if (!cursorVal) this.paginationObj.currentPage = 1
      this.searchInProgress = true
      this.tableLoader = true
      this.searchAllOrdersVal = (this.searchAllOrdersVal || '').replaceAll('#', '%23')
      const query = `&cursor=${cursorVal ? cursorVal : ''}&limit=${this.maximumItems}&${this.filters.includes('on_hold') ? 'on_hold=true' : this.filters.includes('rto_requested') ? 'rto_requested=true' : `${ this.$route.name === 'head-of-fleet-in-house-orders' ? 'status=in_transit' : `status=${this.filters}`}`}&${this.criteria}_after=${this.fromDate ? this.fromDate : ''}&${this.criteria}_before=${this.toDate ? this.toDate : ''}&${this.selectedCriteria.value ? this.selectedCriteria.value : this.searchCriteria[0].value}=${this.searchAllOrdersVal}`
      sendRequest(true, false, this, `api/v1/delivery-orders/?${this.$route.name === 'head-of-fleet-in-house-orders' ? 'current_warehouse' : 'outbound_warehouse'}=${this.warehousesDic[this.$route.params.warehouseID]}${query}`, 'get', null, true, 
        (response) => {
          this.selected = []
          this.shipments = response.data.results
          this.paginationObj.currentCursor = cursorVal ? cursorVal : ''
          this.paginationObj.next = response.data.next && new URL(response.data.next).searchParams.get('cursor')
          this.paginationObj.previous = response.data.previous && new URL(response.data.previous).searchParams.get('cursor')
          this.tableLoader = false
          this.searchedValue = this.searchAllOrdersVal
        }
      )
      this.searchInProgress = false
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    }
  },
  components: {
    ExportButton,
    PrintLabelButton,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    TableFilter,
    ShipbluCursorPagination,
    OrderViewPanel
  },
  mounted () {
    this.$emit('setAppClasses', 'shipment-page')
  },
  created () {
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    common.manageLoadWarehouses(this.formatWarehouses, this)
    if (this.$route.query.order) {
      this.showPanel = true
    } else {
      this.showPanel = false
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
#order-label-print{
  display: none;
  visibility: hidden;
}
</style>